import { __rest, __assign } from 'tslib';
import * as React from 'react';

var ThirdPartyScripts = function (_a) {
    var scripts = _a.scripts, Head = _a.Head;
    return (React.createElement(React.Fragment, null, scripts === null || scripts === void 0 ? void 0 : scripts.filter(function (script) { return script.conditions(); }).map(function (_a) {
        var id = _a.id, src = _a.src; _a.conditions; var scriptSnippet = _a.scriptSnippet, initializeArea = _a.initializeArea, _b = _a.async, async = _b === void 0 ? true : _b, rest = __rest(_a, ["id", "src", "conditions", "scriptSnippet", "initializeArea", "async"]);
        var scriptElement = (React.createElement("script", __assign({ id: id, key: id, src: src }, (scriptSnippet ? { dangerouslySetInnerHTML: { __html: scriptSnippet } } : {}), (async ? { async: true } : {}), rest)));
        return initializeArea === 'top' && Head ? React.createElement(Head, { key: id }, scriptElement) : scriptElement;
    })));
};

export { ThirdPartyScripts as default };
//# sourceMappingURL=ThirdPartyScripts.esm.js.map
